import React, { Component } from 'react';
import UprinceNavigation from '../../shared/uprinceNavigation/cuProjectNavigation/component';
import HumanResourceMainLayout from './humanResourceMainLayout';
import { getContractingUnit } from '../../shared/util';


interface Props {
  currentUser: any
}

interface State {
  isContractUnit: boolean;
  isProject: boolean;
}

export class HumanResource extends Component<Props, State> {
  render() {
    return (
      <UprinceNavigation
        currentUser={this.props.currentUser}
        selectedNavigationIndex={`/CU/${getContractingUnit()}/time_clock`}
      >
        <HumanResourceMainLayout/>
      </UprinceNavigation>
    );
  }
}

export default (HumanResource);
